import { createFileRoute } from '@tanstack/react-router';
import { EstimateFormPage } from './form';

export const Route = createFileRoute('/_dashboard/dashboard/estimates/$id/edit')({
  component: EditEstimatePage,
});

function EditEstimatePage() {
  const { id } = Route.useParams();
  // TODO: Add custom fields editing — see contacts/new.tsx for pattern
  return <EstimateFormPage editId={id} />;
}
